import { Backend, ContractBackend } from './backends';
import { EnvironmentEnum } from './enums';
import { config as contractLocal } from './environments/contract-local';
import { config as dvp } from './environments/dvp';
import { config as local } from './environments/local';
import { config as midBackLocal } from './environments/midback-local';
import { config as ppd } from './environments/ppd';
import { config as prd } from './environments/prd';
import { config as rec2 } from './environments/rec2';
import { config as rec3 } from './environments/rec3';
import { config as rec6 } from './environments/rec6';
import { config as test } from './environments/test';
import { backendId, BaseBackendInterface } from './types';

/**
 * @public
 */
export class BackendLoader {
  private backends: (Backend | ContractBackend)[] = [];

  constructor(backends: BaseBackendInterface<Record<string, unknown>>[]) {
    this.backends = backends.map((backend) => {
      if (backend.id === 'contract') {
        return new ContractBackend(backend);
      } else {
        return new Backend(backend);
      }
    });
  }

  getBackend(backendId: backendId) {
    return this.backends.find((b) => b.id === backendId);
  }

  get contract(): ContractBackend {
    return this.getBackend('contract') as ContractBackend;
  }

  get contractBackends() {
    return this.backends.filter((b) => ['contract', 'customer', 'core', 'portal', 'user'].includes(b.id));
  }

  isContractLocal(backendId: backendId) {
    return this.isContract(backendId) && this.contractBackends.some((b) => b.baseUrl.includes('localhost'));
  }

  isContract(backendId: backendId): boolean {
    return this.contractBackends.some((b) => b.id === backendId);
  }

  isSupplyDataUrl(url: string): boolean {
    return this.backends.find((b) => b.id === 'supplyData' && b.baseUrl === url) !== undefined;
  }
}

export const ApiEnv: Record<EnvironmentEnum, BackendLoader> = {
  [EnvironmentEnum.local]: new BackendLoader(local.backends),
  [EnvironmentEnum['contract-local']]: new BackendLoader(contractLocal.backends),
  [EnvironmentEnum['midback-local']]: new BackendLoader(midBackLocal.backends),
  [EnvironmentEnum.dvp]: new BackendLoader(dvp.backends),
  [EnvironmentEnum.test]: new BackendLoader(test.backends),
  [EnvironmentEnum.rec2]: new BackendLoader(rec2.backends),
  [EnvironmentEnum.rec3]: new BackendLoader(rec3.backends),
  [EnvironmentEnum.rec6]: new BackendLoader(rec6.backends),
  [EnvironmentEnum.ppd]: new BackendLoader(ppd.backends),
  [EnvironmentEnum.prd]: new BackendLoader(prd.backends),
};
